import _ from "lodash";
import update from "immutability-helper";
import {
  createLikeMutation,
  deleteLikeMutation,
  deletePostMutation,
  updatePostMutation,
  bulkPostsActionMutation,
  addSeenMutation,
} from "Post/modules/PostMutations";
import {
  createFolderMutationV2,
  deleteFolderMutation,
  updateFolderMutationV2,
} from "Journal/modules/JournalMutations";
import { getCourseFoldersDetailsQuery } from "Journal/modules/JournalQuery";

import {
  getCourseJournalFeedFromCache,
  writeCourseJournalFeedToCache,
  writePostDetailFragment,
  readActivityLikesAndCommentsFragment,
  writeActivityLikesAndCommentsFragment,
} from "Post/modules/PostGraphqlHelpers";

import {
  readRoutineLikesAndCommentsFragment,
  writeRoutineLikesAndCommentsFragment,
} from "AppComponents/Routines/modules/RoutineGraphqlhelpers";
import {
  getCourseAllStudentQuery,
  getCoursePostFeedQuery,
  getPostDetailQuery,
} from "Post/modules/PostQuery";
import { generateRandomId } from "Utils";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { getFieldUids } from "modules/TaggableElementsUtils";

import {
  hasTranslationPermission,
  getPostTranslationFilter,
  isPortfolioReviewSetupEnabledAndIsReviewRoute,
  isPortfolioReviewSetupEnabled,
  isPortfolioFilterRevamp,
  isPortfolioRevampAndIsJournalRoute,
  getPostDurationFilters,
} from "Post/utils";
import client from "lib/apolloClient/client";
import { isDPSubjectJournalEnabled } from "AppComponents/Post/utils";
import moment from "moment";
import { updatePostDateMutation } from "AppComponents/Post/modules/PostMutations";
import { writeProcessJournalInCache } from "routes/routes/Teacher/routes/Projects/routes/ProjectDetails/routes/ProcessJournal/modules/GraphqlHelpers";
import { getPostFeedFilters } from "./Utils";
import { getSettingValue } from "modules/PermissionModule";
import { CURRICULUM_TYPE_DP } from "Constants/stringConstants";

import {
  getSelectedAcademicYearId,
  getSelectedCurriculumId,
} from "modules/CommonSelectors";
import { getOrganizationPostFeedQuery } from "Teacher/routes/PortfolioReview/modules/PortfolioReviewQuery";

export const NAME = "journal";

export const TOGGLE_LOADING = "TOGGLE_LOADING" + " " + NAME;
export const UPDATE_FILTER_OBJECT = "UPDATE_FILTER_OBJECT" + " " + NAME;

export const toggleLoading = data => {
  return {
    type: TOGGLE_LOADING,
    data,
  };
};

export const updateFilterObject = data => {
  return { type: UPDATE_FILTER_OBJECT, data: data };
};

export const createFolder = ({ name, color }) => {
  return async (dispatch, getState) => {
    const courseId = getState().teacher.selected_class.selected_course;
    try {
      const result = await client.mutate({
        mutation: createFolderMutationV2,
        variables: {
          courseId,
          name: name,
          color,
          type: "JOURNAL",
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getCourseFoldersDetailsQuery,
            variables: { courseId: courseId },
          },
        ],
      });
      const response = _.get(
        result,
        "data.platform.createFolder.response",
        null
      );
      const warning = _.get(result, "data.platform.createFolder.warning", null);
      if (!_.isNil(response)) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:folder_successfully_action",
            locale_params: [
              { key: "action", value: "toastMsgs:created", isPlainText: false },
            ],
            type: "success",
            position: "toast-bottom-left",
          })
        );
      } else if (!_.isNil(warning)) {
        dispatch(
          setToastMsg(
            _.get(warning, "code") == "FOLDER_ALREADY_EXSITS"
              ? {
                  msg: "toastMsgs:label_with_same_name",
                  locale_params: [
                    {
                      key: "label",
                      value: "common:folder",
                      isPlainText: false,
                    },
                  ],
                }
              : {
                  msg: "toastMsgs:something_went_wrong",
                }
          )
        );
      }
    } catch (err) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw err;
    }
  };
};

export const updateFolder = ({ id, name, color }) => {
  return async (dispatch, getState) => {
    const courseId = _.get(
      getState(),
      "teacher.selected_class.selected_course",
      ""
    );
    try {
      const result = await client.mutate({
        mutation: updateFolderMutationV2,
        variables: {
          id,
          name: name,
          color,
          type: "JOURNAL",
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getCourseFoldersDetailsQuery,
            variables: { courseId: courseId },
          },
        ],
      });
      const response = _.get(
        result,
        "data.platform.updateFolder.response",
        null
      );
      const warning = _.get(result, "data.platform.updateFolder.warning", null);
      if (!_.isNil(response)) {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:folder_successfully_action",
            locale_params: [
              { key: "action", value: "toastMsgs:updated", isPlainText: false },
            ],
            type: "success",
            position: "toast-bottom-left",
          })
        );
      } else if (!_.isNil(warning)) {
        dispatch(
          setToastMsg(
            _.get(warning, "code") == "FOLDER_ALREADY_EXSITS"
              ? {
                  msg: "toastMsgs:label_with_same_name",
                  locale_params: [
                    {
                      key: "label",
                      value: "common:folder",
                      isPlainText: false,
                    },
                  ],
                }
              : {
                  msg: "toastMsgs:something_went_wrong",
                }
          )
        );
      }
    } catch (err) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw err;
    }
  };
};

export const deleteFolder = id => {
  return async (dispatch, getState) => {
    const courseId = getState().teacher.selected_class.selected_course;
    try {
      await client.mutate({
        mutation: deleteFolderMutation,
        variables: {
          id,
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getCourseFoldersDetailsQuery,
            variables: { courseId: courseId },
          },
        ],
      });
      setToastMsg({
        msg: "toastMsgs:folder_successfully_action",
        locale_params: [
          { key: "action", value: "toastMsgs:deleted", isPlainText: false },
        ],
        type: "success",
        position: "toast-bottom-left",
      });
    } catch (err) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

const updateFiltersObject = filters => {
  let updatedFilters = filters;
  if (updatedFilters?.state === "IN_APPROVAL_STAFF") {
    updatedFilters = {
      ...updatedFilters,
      state: "IN_APPROVAL",
    };
  }
  return updatedFilters;
};

export const bulkPostsAction = ({
  action,
  shouldPassCourseId = true,
  courseIdFromParent,
  callback,
  curriculumProgramIdFromProps,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    try {
      const filters = getState()?.journal?.filters;
      const courseId =
        getState().teacher.selected_class.selected_course || courseIdFromParent;
      const curriculumProgramType = getState().platform.currentCurriculumProgram
        .type;
      const fieldUids = getFieldUids({ curriculumProgramType });
      dispatch(toggleLoading(true));

      const translationFilter = getPostTranslationFilter({
        userInfo,
        shouldTranslate: false,
        handleTranslation: hasTranslationPermission(),
      });

      const postFeedFilters = getPostFeedFilters({
        userType: userInfo.user_type,
        filters: _.get(getState(), "journal.filters", {}),
      });
      const reviewerPostFilters = {
        ...(shouldPassCourseId ? { courseId } : {}),
        curriculumProgramId: curriculumProgramIdFromProps
          ? curriculumProgramIdFromProps
          : getSelectedCurriculumId(getState()),
        creatorType: "staff",
        fetchOnlyRevieweePosts: true,
      };
      await client.mutate({
        mutation: bulkPostsActionMutation,
        variables: {
          input: {
            ...(isPortfolioRevampAndIsJournalRoute()
              ? {
                  ...filters,
                  duration: {
                    fromDate: !_.isNull(
                      _.get(filters, "duration.fromDate", null)
                    )
                      ? moment(
                          filters?.duration?.fromDate.format("YYYY-MM-DD")
                        ).toISOString()
                      : null,
                    toDate: !_.isNull(_.get(filters, "duration.toDate", null))
                      ? moment(filters?.duration?.toDate.format("YYYY-MM-DD"))
                          .add({ hours: 23, minutes: 59 })
                          .toISOString()
                      : null,
                  },
                }
              : filters),
            feedTypes: ["PORTFOLIO"],
            action,
            ...(isPortfolioReviewSetupEnabledAndIsReviewRoute()
              ? reviewerPostFilters
              : { courseId }),
            ...(isPortfolioReviewSetupEnabledAndIsReviewRoute()
              ? { state: "IN_APPROVAL" }
              : {}),
          },
        },
        refetchQueries: isPortfolioReviewSetupEnabledAndIsReviewRoute()
          ? [
              {
                query: getOrganizationPostFeedQuery,
                variables: {
                  filters: {
                    curriculumProgramIds: [
                      curriculumProgramIdFromProps
                        ? curriculumProgramIdFromProps
                        : getSelectedCurriculumId(getState()),
                    ],
                    state: "IN_APPROVAL",
                    creatorType: "staff",
                    academicYears: [getSelectedAcademicYearId(getState())],
                    fetchOnlyRevieweePosts: true,
                    ...(shouldPassCourseId ? { courseIds: [courseId] } : {}),
                    feedTypes: ["PORTFOLIO"],
                  },
                  organizationId: _.get(getState(), "login.userInfo.org_id"),
                  uids: fieldUids,
                  translationFilter: translationFilter,
                  isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
                },
              },
            ]
          : [
              {
                query: getCourseAllStudentQuery,
                variables: { id: courseId },
              },
              {
                query: getCoursePostFeedQuery,
                variables: {
                  id: courseId,
                  filters: postFeedFilters,
                  uids: fieldUids,
                  translationFilter: translationFilter,
                  isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
                },
              },
            ],
      });

      let actionString = "";
      const additionalFilters = {
        folderIds: undefined,
        duration: undefined,
        searchText: undefined,
      };
      switch (action) {
        case "APPROVE":
          actionString = "approved";
          dispatch(
            updateFilterObject({
              state: "PUBLISHED",
              ...(isPortfolioFilterRevamp() ? additionalFilters : {}),
            })
          );
          break;

        case "REJECT":
          actionString = "rejected";
          break;

        case "DELETE":
          actionString = "deleted";
          break;

        default:
          actionString = "updated";
      }
      dispatch(toggleLoading(false));
      dispatch(
        setToastMsg({
          msg: `toastMsgs:posts_action_successfully`,
          locale_params: [
            {
              key: "action",
              value: `toastMsgs:${actionString}`,
              isPlainText: false,
            },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
      _.isFunction(callback) && callback();
    } catch (e) {
      dispatch(toggleLoading(false));
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const bulkPostsDraftOrPublishAction = ({ action }) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    try {
      const courseId = getState().teacher.selected_class.selected_course;
      const curriculumProgramType = getState().platform.currentCurriculumProgram
        .type;
      const fieldUids = getFieldUids({ curriculumProgramType });

      dispatch(toggleLoading(true));

      const translationFilter = getPostTranslationFilter({
        userInfo,
        shouldTranslate: false,
        handleTranslation: hasTranslationPermission(),
      });

      const postFeedFilters = getPostFeedFilters({
        userType: userInfo.user_type,
        filters: isPortfolioReviewSetupEnabled()
          ? updateFiltersObject(
              getReviewerPostFilters(
                _.get(getState(), "journal.filters"),
                userInfo
              )
            )
          : _.get(getState(), "journal.filters", {}),
      });
      const input = {
        states: ["IN_APPROVAL", "REJECTED"],
        courseId,
        orderBy: "CREATED_AT",
        showPrivate: true,
        isShowHiddenFromStudents: true,
        unTagged: false,
        action,
        curriculumProgramId: getSelectedCurriculumId(getState()),
        creatorType: "staff",
        createdBy: userInfo.id,
        feedTypes: ["PORTFOLIO"],
        duration:
          isPortfolioRevampAndIsJournalRoute() &&
          !_.isUndefined(_.get(getState(), "journal.filters.duration"))
            ? getPostDurationFilters(_.get(getState(), "journal.filters", {}))
            : null,
      };
      await client.mutate({
        mutation: bulkPostsActionMutation,
        variables: {
          input,
        },
        refetchQueries: [
          {
            query: getCourseAllStudentQuery,
            variables: { id: courseId },
          },
          {
            query: getCoursePostFeedQuery,
            variables: {
              id: courseId,
              filters: postFeedFilters,
              uids: fieldUids,
              translationFilter: translationFilter,
              isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
            },
          },
        ],
      });

      let actionString = "";
      const additionalFilters = {
        folderIds: undefined,
        duration: undefined,
        searchText: undefined,
      };

      const updateFilterObjectAction = state => {
        dispatch(
          updateFilterObject({
            state,
            ...(isPortfolioFilterRevamp() ? additionalFilters : {}),
          })
        );
      };
      switch (action) {
        case "APPROVE":
          actionString = "approved";
          updateFilterObjectAction("PUBLISHED");
          break;
        case "DRAFT":
          actionString = "draft";
          updateFilterObjectAction("DRAFT");
          break;
        case "REJECT":
          actionString = "rejected";
          break;

        case "DELETE":
          actionString = "deleted";
          break;

        default:
          actionString = "updated";
      }
      dispatch(toggleLoading(false));
      dispatch(
        setToastMsg({
          msg: `toastMsgs:posts_action_successfully`,
          locale_params: [
            {
              key: "action",
              value: `toastMsgs:${actionString}`,
              isPlainText: false,
            },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (e) {
      dispatch(toggleLoading(false));
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updatePostStatus = (
  postId,
  status = "DRAFT",
  comment = {},
  showToast = true,
  publishedAt = undefined,
  doOptimisticUpdate = true,
  courseIdFromParent = undefined,
  approvePostCallback = undefined
) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const courseId =
      getState().teacher.selected_class.selected_course || courseIdFromParent;
    const filters = getState()?.journal?.filters;
    const currentState = _.get(filters, "state", "DRAFT");
    const userId = userInfo.id;
    const curriculumProgramType = getState().platform.currentCurriculumProgram
      .type;
    const fieldUids = getFieldUids({ curriculumProgramType });
    const translationFilter = getPostTranslationFilter({
      userInfo,
      shouldTranslate: false,
      handleTranslation: hasTranslationPermission(),
    });
    const academicYearId = getSelectedAcademicYearId(getState());
    const updatedPostFilters = {
      duration: _.get(filters, "duration")
        ? getPostDurationFilters(filters)
        : undefined,
      postSearchText: _.get(filters, "searchText", undefined),
      orderBy: _.get(filters, "orderBy"),
      academicYearId,
      ...(isPortfolioFilterRevamp()
        ? { showPrivate: !_.isEqual(userInfo.user_type, "parent") }
        : {}),
    };

    const isCourseIdSelected = _.get(
      getState(),
      "portfolioReview.selectedCourseId",
      null
    );

    const userType = userInfo.user_type;
    const { approveComment, rejectComment } = comment;
    if (!doOptimisticUpdate) {
      try {
        await client.mutate({
          mutation: updatePostMutation,
          variables: {
            postId: postId,
            courseId,
            updatedBy: userId,
            state: status,
            approvComment: approveComment,
            rejectComment: rejectComment,
            publishedAt: publishedAt,
          },
          refetchQueries: isPortfolioReviewSetupEnabledAndIsReviewRoute()
            ? [
                {
                  query: getOrganizationPostFeedQuery,
                  variables: {
                    filters: {
                      curriculumProgramIds: [
                        getSelectedCurriculumId(getState()),
                      ],
                      state: "IN_APPROVAL",
                      creatorType: "staff",
                      academicYears: [getSelectedAcademicYearId(getState())],
                      fetchOnlyRevieweePosts: true,
                      ...(isCourseIdSelected
                        ? { courseIds: [isCourseIdSelected] }
                        : {}),
                      feedTypes: ["PORTFOLIO"],
                    },
                    organizationId: _.get(getState(), "login.userInfo.org_id"),
                    uids: fieldUids,
                    translationFilter: translationFilter,
                    isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
                  },
                },
              ]
            : [
                {
                  query: getPostDetailQuery,
                  variables: {
                    id: postId,
                  },
                },
              ],
        });
        if (showToast) {
          dispatch(
            setToastMsg({
              msg:
                status === "REJECTED"
                  ? "journal:post_return_for_review"
                  : "toastMsgs:post_successfully_published",
              type: "success",
              position: "toast-bottom-left",
            })
          );
        }
        _.isFunction(approvePostCallback) && approvePostCallback();
        return true;
      } catch (err) {
        if (showToast) {
          dispatch(setToastMsg("toastMsgs:something_went_wrong"));
        }
        return false;
      }
    }

    const postFeedFilters = getPostFeedFilters({
      userType: userType,
      filters: isPortfolioReviewSetupEnabled()
        ? updateFiltersObject(
            getReviewerPostFilters(
              _.get(getState(), "journal.filters", {}),
              userInfo
            )
          )
        : _.get(getState(), "journal.filters", {}),
      userId: userInfo.id,
    });
    let courseDetails = getCourseJournalFeedFromCache({
      courseId: courseId,
      filters: postFeedFilters,
      uids: fieldUids,
      translationFilter: translationFilter,
      isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
    });

    let posts = _.get(courseDetails, "posts", {});
    let edges = _.get(posts, "edges", []);
    const postDetail = _.find(edges, obj => obj.node.id == postId);
    if (_.isEmpty(postDetail)) {
      return;
    }

    // if post is scheduled and user is trying to save as draft it, then set publishedAt to current time
    let currentPublishedAt = _.get(postDetail, "node.publishedAt");
    if (!_.isNil(currentPublishedAt)) {
      if (moment(currentPublishedAt).isAfter(moment()) && status === "DRAFT") {
        currentPublishedAt = moment().toISOString();
      }
    }

    const isPostApprovalEnabled = getSettingValue({
      name: "EnablePostApprovalRequiredForNewStudents",
      courseId,
      organizationId: userInfo.org_id,
      userId,
    });

    /**
     * HACK: Here mutation response is not returning all details of post that is required to update cache.
     * So, we are using same object that is used in readQuery, to update cache.
     */
    const updatedPost = {
      ...postDetail.node,
      state: status,
      publishedAt: currentPublishedAt,
    };
    const createdByType = _.get(postDetail, "node.createdBy.type");
    const isUserTypeStaffAndInApproval =
      createdByType === "staff" && currentState === "IN_APPROVAL";
    try {
      await client.mutate({
        mutation: updatePostMutation,
        variables: {
          postId: postId,
          courseId,
          updatedBy: userId,
          state: status,
          approvComment: approveComment,
          rejectComment: rejectComment,
          publishedAt: status === "DRAFT" ? currentPublishedAt : publishedAt,
        },
        optimisticResponse: {
          __typename: "Mutation",
          documentation: {
            __typename: "DocumentationMutations",
            updatePost: {
              ...postDetail.node,
              state: status,
            },
          },
        },
        update: (
          cache,
          {
            data: {
              documentation: { updatePost },
            },
          }
        ) => {
          courseDetails = getCourseJournalFeedFromCache({
            courseId: courseId,
            filters: postFeedFilters,
            uids: fieldUids,
            translationFilter: translationFilter,
            isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
          });
          posts = _.get(courseDetails, "posts", {});
          edges = _.filter(
            _.get(posts, "edges", []),
            obj => obj.node.id != postId
          );
          if (currentState != "ALL") {
            writeCourseJournalFeedToCache({
              courseId: courseId,
              data: {
                ...courseDetails,
                posts: {
                  ...posts,
                  edges,
                  totalCount: posts.totalCount - 1,
                },
              },
              filters: {
                ...postFeedFilters,
                ...(userType == "staff" && currentState == "PUBLISHED"
                  ? {}
                  : {
                      state: isUserTypeStaffAndInApproval
                        ? "IN_APPROVAL_STAFF"
                        : currentState,
                    }),
              },
              uids: fieldUids,
              translationFilter: translationFilter,
              isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
            });
            if (currentState == "IN_APPROVAL") {
              if (posts.totalCount - 1 == 0 && isPostApprovalEnabled == false) {
                dispatch(updateFilterObject({ state: "PUBLISHED" }));
              }
            }
          } else {
            writeCourseJournalFeedToCache({
              courseId: courseId,
              data: {
                ...courseDetails,
                posts: {
                  ...posts,
                  edges: [
                    { node: updatedPost, __typename: "PostEdge" },
                    ...edges,
                  ],
                  totalCount: posts.totalCount,
                },
              },
              filters: {
                ...(isPortfolioReviewSetupEnabled()
                  ? updateFiltersObject(
                      getReviewerPostFilters(filters, userInfo)
                    )
                  : filters),
                state: currentState,
              },
              uids: fieldUids,
              translationFilter: translationFilter,
              isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
            });
          }

          const destinationFilters = {
            ...postFeedFilters,
            ...(isUserTypeStaffAndInApproval
              ? { state: "IN_APPROVAL_STAFF" }
              : {}),
          };
          if (userType == "staff" && status == "PUBLISHED") {
            _.unset(destinationFilters, "state");
            destinationFilters.states = ["PUBLISHED", "SCHEDULED"];
          } else {
            destinationFilters.state = status;
          }

          courseDetails = getCourseJournalFeedFromCache({
            courseId: courseId,
            filters: destinationFilters,
            uids: fieldUids,
            translationFilter: translationFilter,
            isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
          });
          if (!_.isEmpty(courseDetails)) {
            posts = _.get(courseDetails, "posts", {});
            edges = _.get(posts, "edges", []);
            edges = [{ node: updatedPost, __typename: "PostEdge" }, ...edges];
            writeCourseJournalFeedToCache({
              courseId: courseId,
              data: {
                ...courseDetails,
                posts: {
                  ...posts,
                  edges,
                  totalCount: posts.totalCount + 1,
                },
              },
              filters: destinationFilters,
              uids: fieldUids,
              translationFilter: translationFilter,
              isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
            });
          }
        },
        refetchQueries: courseId
          ? [
              {
                query: getCourseAllStudentQuery,
                variables: { id: courseId, filters: updatedPostFilters },
                userArchivedFilters: { academicYearId },
              },
            ]
          : [],
      });
      let toastMessage = "toastMsgs:post_successfully_published";
      let locale_params = {
        key: "action",
        value: "toastMsgs:updated",
        isPlainText: false,
      };
      switch (status) {
        case "DRAFT":
          toastMessage = "toastMsgs:post_saved_as_draft";
          break;
        case "IN_APPROVAL":
          toastMessage = "toastMsgs:post_moved_to_in_approval";
          break;
        case "REJECTED":
          toastMessage = "toastMsgs:post_returned_for_review";
          break;
        case "PUBLISHED":
          if (
            !_.isNil(publishedAt) &&
            moment(publishedAt).isAfter(moment().toISOString())
          ) {
            toastMessage = "toastMsgs:post_scheduled_successfully_with_time";
            locale_params = [
              {
                key: "time",
                value: moment(publishedAt).format("lll"),
                isPlainText: true,
              },
            ];
          } else toastMessage = "toastMsgs:post_successfully_published";
          break;
      }

      if (showToast) {
        dispatch(
          setToastMsg({
            msg: toastMessage,
            locale_params: locale_params,
            type: "success",
            position: "toast-bottom-left",
          })
        );
      }
      if (
        isDPSubjectJournalEnabled(curriculumProgramType) &&
        _.includes(["DRAFT", "PUBLISHED"], status)
      ) {
        //dispatch(updateFilterObject({ state: status }));
      }
      return true;
    } catch (err) {
      if (showToast) {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
      return false;
    }
  };
};

const getReviewerPostFilters = (filters, userInfo) => {
  const state = _.get(filters, "state", "ALL");
  const filterWithoutState = _.omit(filters, ["state"]);
  const userType = userInfo.user_type;
  if (
    userType === "staff" &&
    (state === "IN_APPROVAL_STAFF" || state === "IN_APPROVAL")
  ) {
    return {
      ...(filters?.state === "IN_APPROVAL_STAFF"
        ? _.omitBy(filterWithoutState, _.isUndefined)
        : _.omitBy(filters, _.isUndefined)),
      ...(state === "IN_APPROVAL_STAFF"
        ? {
            states:
              filters.state === "IN_APPROVAL_STAFF"
                ? ["IN_APPROVAL", "REJECTED"]
                : filters.state,
          }
        : {}),
      ...((filters.state === "IN_APPROVAL" ||
        filters.state === "IN_APPROVAL_STAFF") && {
        creatorType:
          userType === "staff" && filters.state === "IN_APPROVAL_STAFF"
            ? "staff"
            : "student",
      }),
      ...(filters.state === "IN_APPROVAL_STAFF" && { createdBy: userInfo.id }),
    };
  }
  return _.omitBy(filters, _.isUndefined);
};

export const deletePost = postId => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const courseId = getState().teacher.selected_class.selected_course;
    const curriculumProgramType = getState().platform.currentCurriculumProgram
      .type;
    const fieldUids = getFieldUids({ curriculumProgramType });
    const translationFilter = getPostTranslationFilter({
      userInfo,
      shouldTranslate: false,
      handleTranslation: hasTranslationPermission(),
    });

    const postFeedFilters = getPostFeedFilters({
      userType: userInfo.user_type,
      filters: isPortfolioReviewSetupEnabled()
        ? updateFiltersObject(
            getReviewerPostFilters(
              _.get(getState(), "journal.filters", {}),
              userInfo
            )
          )
        : _.get(getState(), "journal.filters", {}),
    });
    if (
      userInfo.user_type == "student" &&
      !isDPSubjectJournalEnabled(curriculumProgramType)
    ) {
      if (_.has(postFeedFilters, "state")) postFeedFilters.state = undefined;
    }

    const courseJournalFeed = getCourseJournalFeedFromCache({
      courseId,
      filters: postFeedFilters,
      uids: fieldUids,
      translationFilter: translationFilter,
      isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
    });

    const updatePostEdges = _.filter(
      _.get(courseJournalFeed, "posts.edges", []),
      item => item.node.id != postId
    );
    const updatedPosts = {
      ...courseJournalFeed.posts,
      edges: updatePostEdges,
      totalCount: updatePostEdges.length,
    };
    const updatedCourseFeed = update(courseJournalFeed, {
      posts: { $set: updatedPosts },
    });

    try {
      await client.mutate({
        mutation: deletePostMutation,
        variables: {
          id: postId,
        },
        optimisticResponse: {
          __typename: "Mutation",
          documentation: {
            __typename: "DocumentationMutations",
            deletePost: { isSuccess: true, __typename: "DeleteOutput" },
          },
        },
        update: (
          cache,
          {
            data: {
              documentation: { deletePost },
            },
          }
        ) => {
          if (deletePost && deletePost.isSuccess) {
            writeCourseJournalFeedToCache({
              courseId,
              filters: isPortfolioReviewSetupEnabled()
                ? updateFiltersObject(
                    getReviewerPostFilters(postFeedFilters, userInfo)
                  )
                : postFeedFilters,
              data: updatedCourseFeed,
              uids: fieldUids,
              translationFilter: translationFilter,
              isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
            });
          } else {
            writeCourseJournalFeedToCache({
              courseId,
              filters: postFeedFilters,
              data: courseJournalFeed,
              uids: fieldUids,
              translationFilter: translationFilter,
              isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
            });
          }
        },
        refetchQueries: isPortfolioReviewSetupEnabledAndIsReviewRoute()
          ? [
              {
                query: getOrganizationPostFeedQuery,
                variables: {
                  filters: {
                    curriculumProgramIds: [getSelectedCurriculumId(getState())],
                    state: "IN_APPROVAL",
                    creatorType: "staff",
                    academicYears: [getSelectedAcademicYearId(getState())],
                    fetchOnlyRevieweePosts: true,
                    feedTypes: ["PORTFOLIO"],
                  },
                  organizationId: _.get(getState(), "login.userInfo.org_id"),
                  uids: fieldUids,
                  translationFilter: translationFilter,
                  isDP: curriculumProgramType === CURRICULUM_TYPE_DP,
                },
              },
            ]
          : [
              {
                query: getCourseAllStudentQuery,
                variables: { id: courseId },
              },
            ],
      });
      dispatch(
        setToastMsg({
          msg: "toastMsgs:post_action_successfully",
          locale_params: [
            { key: "action", value: "toastMsgs:deleted", isPlainText: false },
          ],
          type: "success",
          position: "toast-bottom-left",
        })
      );
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};
export const createPostLike = ({
  postId,
  parentType = "POST",
  postDetails,
  fragmentName = "journalPost",
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const {
      id,
      first_name: firstName,
      last_name: lastName,
      middle_name: middleName,
      preferred_name: preferredName,
      pronouns,
      suffix,
      user_type: userType,
    } = userInfo;
    const studentNameFields = { pronouns, suffix, preferredName };
    try {
      if (parentType === "STUDENT_ACTIVITY") {
        const likesAndComments = readActivityLikesAndCommentsFragment({
          id: postId,
        });

        const likes = _.get(likesAndComments, ["likes", "edges"], []);

        const newLike = {
          id: generateRandomId(),
          user: {
            id,
            firstName,
            lastName,
            middleName,
            type: userType,
            __typename: "User",
            ...(_.isEqual(userType, "student") && studentNameFields),
          },
          __typename: "Like",
        };

        const updatedLikes = [
          ...likes,
          { node: newLike, __typename: "LikeEdge" },
        ];

        const likeObject = {
          ..._.get(likesAndComments, "likes", {}),
          edges: updatedLikes,
          totalCount: _.get(likesAndComments, ["likes", "totalCount"], 0) + 1,
        };

        setTimeout(() => {
          writeActivityLikesAndCommentsFragment({
            id: postId,
            data: { ...likesAndComments, likes: likeObject },
          });
        });
      } else if (parentType === "STUDENT_TEMPLATE_RESPONSE") {
        const likesAndComments = readRoutineLikesAndCommentsFragment({
          id: postId,
        });

        const likes = _.get(likesAndComments, ["likes", "edges"], []);

        const newLike = {
          id: generateRandomId(),
          user: {
            id,
            firstName,
            lastName,
            middleName,
            type: userType,
            __typename: "User",
            ...(_.isEqual(userType, "student") && studentNameFields),
          },
          __typename: "Like",
        };

        const updatedLikes = [
          ...likes,
          { node: newLike, __typename: "LikeEdge" },
        ];

        const likeObject = {
          ..._.get(likesAndComments, "likes", {}),
          edges: updatedLikes,
          totalCount: _.get(likesAndComments, ["likes", "totalCount"], 0) + 1,
        };

        setTimeout(() => {
          writeRoutineLikesAndCommentsFragment({
            id: postId,
            data: { ...likesAndComments, likes: likeObject },
          });
        });
      } else {
        const likes = postDetails.likes.edges;

        const newLike = {
          id: generateRandomId(),
          user: {
            id,
            firstName,
            lastName,
            middleName,
            type: userType,
            __typename: "User",
            ...(_.isEqual(userType, "student") && studentNameFields),
          },
          __typename: "Like",
        };

        const updatedLikes = [
          ...likes,
          { node: newLike, __typename: "LikeEdge" },
        ];

        const likedUsersNode = {
          ...postDetails.likes,
          edges: updatedLikes,
          totalCount: postDetails.likes.totalCount + 1,
        };

        writePostDetailFragment({
          postId,
          data: { ...postDetails, likes: likedUsersNode },
          fragmentName,
        });
      }

      await client.mutate({
        mutation: createLikeMutation,
        variables: {
          userId: userInfo.id,
          parentId: postId,
          parentType,
        },
      });
    } catch (e) {
      console.warn("Error in `createPostLike`", e);
      writePostDetailFragment({
        postId,
        data: postDetails,
        fragmentName,
      });
    }
  };
};

export const deletePostLike = ({
  postId,
  parentType = "POST",
  postDetails,
  fragmentName = "journalPost",
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userId = userInfo.id;

    if (parentType === "STUDENT_ACTIVITY") {
      const likesAndComments = readActivityLikesAndCommentsFragment({
        id: postId,
      });

      const likes = _.get(likesAndComments, ["likes", "edges"], []);

      const updatedLikes = _.filter(
        likes,
        item => _.get(item, "node.user.id", "") != userId
      );

      const likeObject = {
        ..._.get(likesAndComments, "likes", {}),
        edges: updatedLikes,
        totalCount: _.size(updatedLikes),
      };

      setTimeout(() => {
        writeActivityLikesAndCommentsFragment({
          id: postId,
          data: { ...likesAndComments, likes: likeObject },
        });
      });
    } else if (parentType === "STUDENT_TEMPLATE_RESPONSE") {
      const likesAndComments = readRoutineLikesAndCommentsFragment({
        id: postId,
      });

      const likes = _.get(likesAndComments, ["likes", "edges"], []);

      const updatedLikes = _.filter(
        likes,
        item => _.get(item, "node.user.id", "") != userId
      );

      const likeObject = {
        ..._.get(likesAndComments, "likes", {}),
        edges: updatedLikes,
        totalCount: _.size(updatedLikes),
      };

      setTimeout(() => {
        writeRoutineLikesAndCommentsFragment({
          id: postId,
          data: { ...likesAndComments, likes: likeObject },
        });
      });
    } else {
      const likes = _.filter(
        postDetails.likes.edges,
        item => _.get(item, "node.user.id", "") != userId
      );

      const likedUsersNode = {
        ...postDetails.likes,
        edges: likes,
        totalCount: likes.length,
      };

      writePostDetailFragment({
        postId,
        data: { ...postDetails, likes: likedUsersNode },
        fragmentName,
      });
    }

    try {
      await client.mutate({
        mutation: deleteLikeMutation,
        variables: {
          userId: userId,
          parentId: postId,
          parentType,
        },
      });
    } catch (e) {
      console.warn("Error in `deletePostLike`", e);
      writePostDetailFragment({
        postId,
        data: postDetails,
        fragmentName,
      });
    }
  };
};

export const markPostAsSeenByUser = ({
  parentIds,
  parentType = "POST",
  userId,
  postDetails,
}) => {
  // ParentIds = array of post-id
  return async (dispatch, getState) => {
    try {
      const userInfo = getUserInfo();
      const seenEdges = postDetails.seen.edges;
      const newSeen = {
        id: generateRandomId(),
        user: { __typename: "User" },
        __typename: "Seen",
      };
      const { id, first_name: firstName, last_name: lastName } = userInfo;
      newSeen["user"] = {
        id,
        __typename: "User",
      };

      const updatedSeenData = [
        ...seenEdges,
        { node: newSeen, __typename: "SeenEdge" },
      ];
      const seenUsersNode = {
        ...postDetails.seen,
        edges: updatedSeenData,
        totalCount: postDetails.seen.totalCount + 1,
      };

      writePostDetailFragment({
        postId: parentIds[0],
        data: { ...postDetails, seen: seenUsersNode },
      });

      const result = await client.mutate({
        mutation: addSeenMutation,
        variables: {
          input: { userId, parentIds, parentType },
        },
      });
    } catch (e) {
      console.error(e);
      writePostDetailFragment({
        postId: parentIds[0],
        data: postDetails,
      });
      //dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const addPostAsSeen = ({ parentIds, parentType = "POST", userId }) => {
  return async (dispatch, getState) => {
    try {
      const result = await client.mutate({
        mutation: addSeenMutation,
        variables: {
          input: { userId, parentIds, parentType },
        },
      });
    } catch (e) {
      console.error(e);
    }
  };
};

export const updatePostDate = data => {
  const userInfo = getUserInfo();
  const postId = _.get(data, "id");
  const date = _.get(data, "date");
  const time = _.get(data, "time");
  const state = _.get(data, "state", "PUBLISHED");
  const isProjectPost = _.get(data, "isProjectPost", false);

  if (_.isNil(postId) || _.isNil(date) || _.isNil(time)) return;
  const updatedDate = moment(
    date.format("YYYY-MM-DD") + " " + time.format("HH:mm")
  );
  return async (dispatch, getState) => {
    const updatedBy = userInfo.id;
    const variables = {
      postId,
      state,
      updatedBy,
      publishedAt: updatedDate,
      createdAt: updatedDate,
    };

    const postDetails = _.cloneDeep(_.get(data, "postDetails"));
    postDetails["publishedAt"] = updatedDate;
    postDetails["createdAt"] = updatedDate;
    try {
      if (isProjectPost) {
        writeProcessJournalInCache({
          postId,
          data: postDetails,
        });
      } else {
        writePostDetailFragment({
          postId,
          data: postDetails,
        });
      }
      const result = await client.mutate({
        mutation: updatePostDateMutation,
        variables: variables,
      });
    } catch (e) {
      if (isProjectPost) {
        writeProcessJournalInCache({
          postId,
          data: _.get(data, "postDetails"),
        });
      } else {
        writePostDetailFragment({
          postId,
          data: _.get(data, "postDetails"),
        });
      }
      dispatch(setToastMsg("common:something_went_wrong"));
    }
  };
};
const REDUCER_HANDLERS = {
  [UPDATE_FILTER_OBJECT]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        filters: { [key]: { $set: params[key] } },
      });
    });

    return state;
  },
  [TOGGLE_LOADING]: (state, action) => {
    return update(state, {
      isLoading: { $set: action.data },
    });
  },
};

const initialState = {
  isLoading: false,
  filters: {
    state: "PUBLISHED",
    orderBy: "PUBLISHED_AT",
  },
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
